import { Button, Col, Modal, Row } from "reactstrap";
import {
  Link,
  Typography,
  Breadcrumbs,
  BannerMessage,
} from "cfa-react-components";
import React, { useEffect, useRef, useState } from "react";
import "./riskInformation.scss";
import RiskInformationFilters from "./riskInformationFilters";
import {
  FAILED,
  IDLE,
  LOADING,
  NEEDS_REFRESH,
  SUCCEEDED,
} from "../../../redux/features/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  refundAnalysisSelector,
  fetchAllRefundAnalysisInformation,
  refundAnalysisFrcSelector,
  refundAnalysisEmailVerifiedSelector,
} from "../../../redux/features/refundAnalysisSlice";
import { RootState } from "../../../redux/store/store";
import RiskInformationSaveModal from "./riskInformationSaveModal";
import RiskInformationExportModal from "./riskInformationExportModal";
import { GridApi } from "ag-grid-community";
import RiskInformationTable from "./riskInformationTable";
import { getOktaUser, getUserPermissions } from "../../../utils/LocalStorage";
import I18n from "../../../../i18n/utils";
import RiskInformationResetModal from "./riskInformationResetModal";

function Sherlock() {
  const dispatch = useDispatch();

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [displayImportModal, setDisplayImportModal] = useState<boolean>(false);
  const [displaySaveModal, setDisplaySaveModal] = useState<boolean>(false);
  const [displayExportModal, setDisplayExportModal] = useState<boolean>(false);
  const [displayResetModal, setDisplayResetModal] = useState<boolean>(false);
  const riskRecordsModified = useRef(new Map());
  const [gridApi, setGridApi] = useState(null);
  const [detailFilters, setDetailFilters] = useState([]);
  const oktaUserInfo = getOktaUser();

  const riskInformationFetchError = useSelector((state: RootState) =>
    state.refundAnalysisInformation.error
      ? state.refundAnalysisInformation.error
      : ""
  );

  const riskInformationReduxStatus = useSelector(
    (state: RootState) =>
      state.refundAnalysisInformation.fetchAllRefundAnalysisStatus
  );

  const saveAllReduxStatus = useSelector(
    (state: RootState) => state.refundAnalysisInformation.saveAllStatus
  );

  const riskInformationList = useSelector(refundAnalysisSelector);
  const frcList = useSelector(refundAnalysisFrcSelector);
  const userEmailValidated = useSelector(refundAnalysisEmailVerifiedSelector);

  const checkUserPerms = () => {
    const treasuryPermissions = getUserPermissions();
    return (
      treasuryPermissions.hasOwnProperty("SHERLOCK_ADMIN") ||
      treasuryPermissions.hasOwnProperty("SUPERUSER")
    );
  };

  const loading = riskInformationReduxStatus === LOADING;
  const saving = saveAllReduxStatus === LOADING;
  const refreshGrid = () => {
    if (gridApi != undefined) {
      (gridApi as GridApi).redrawRows();
    }
  };
  useEffect(() => {
    if (riskInformationReduxStatus == SUCCEEDED && gridApi != undefined) {
      (gridApi as GridApi).redrawRows();
    }
  }, [riskInformationReduxStatus]);

  useEffect(() => {
    if (
      riskInformationReduxStatus === IDLE ||
      riskInformationReduxStatus === NEEDS_REFRESH
    ) {
      let startDateRaw = new Date();
      startDateRaw.setDate(startDateRaw.getDate() - 30);
      const startDate = startDateRaw.toISOString().split("T")[0];

      let endDateRaw = new Date();
      endDateRaw.setDate(endDateRaw.getDate());
      const endDate = endDateRaw.toISOString().split("T")[0];

      const userEmail = oktaUserInfo[1];
      const params = { userEmail, startDate, endDate };
      dispatch(fetchAllRefundAnalysisInformation(params));
      refreshGrid();
    }
    if (riskInformationReduxStatus === FAILED) {
      // setErrorMessage(riskInformationFetchError);
    }
  }, [
    dispatch,
    riskInformationReduxStatus,
    riskInformationFetchError,
    gridApi,
  ]);

  useEffect(() => {
    if (gridApi) {
    }
  }, [gridApi]);

  useEffect(() => {
    if (detailFilters) {
    }
  }, [detailFilters]);

  const showSaveModal = () => {
    if (userEmailValidated) {
      setDisplaySaveModal(true);
    }
  };

  const closeSaveModal = () => {
    setDisplaySaveModal(false);
  };

  const showExportModal = () => {
    setDisplayExportModal(true);
  };

  const closeExportModal = () => {
    setDisplayExportModal(false);
  };

  const showResetModal = () => {
    setDisplayResetModal(true);
  };

  const closeResetModal = () => {
    setDisplayResetModal(false);
  };

  return (
    <Col className={"Sherlock Container"}>
      <Row>
        <div style={{ marginTop: "2rem", display: "inline" }}>
          <Breadcrumbs
            breadcrumbs={[{ label: "Risk Analysis" }, { label: "Sherlock" }]}
          />
        </div>
        <BannerMessage
          style={{ margin: "2rem", display: "inline" }}
          severity="error"
          show={!userEmailValidated}
        >
          Email Address for user ({oktaUserInfo[1]}) is not verified for sending
          emails. Please request verification by sending email to{" "}
          {I18n.t("RISK_ANALYSIS_REQUEST_EMAIL")}
        </BannerMessage>
      </Row>
      <Row style={{ marginTop: "1rem", display: "flex" }}>
        <Col md={2} style={{ display: "flex" }}>
          <div className={"Header"}>
            <Typography
              variant={"h3"}
              style={{ display: "flex", color: "black", alignSelf: "flex-end" }}
            >
              Refund Analysis
            </Typography>
          </div>
        </Col>
        <Col style={{ display: "flex" }}>
          {userEmailValidated && checkUserPerms() ? (
            <div className={"linkDiv"}>
              <Typography
                style={{
                  justifyContent: "bottom",
                  justifySelf: "baseline",
                  marginRight: "2rem",
                }}
              >
                <Link as="a" variant={"standalone"} onClick={showSaveModal}>
                  Save & Send Emails
                </Link>
              </Typography>
              <Typography>
                <Link
                  as="a"
                  variant={"standalone"}
                  onClick={showExportModal}
                  style={{ justifyContent: "right" }}
                >
                  Export CSV
                </Link>
              </Typography>
              <Typography>
                <Link
                  as="a"
                  variant={"standalone"}
                  onClick={showResetModal}
                  style={{ justifyContent: "right", paddingLeft: "2rem" }}
                >
                  Reset
                </Link>
              </Typography>
            </div>
          ) : (
            <div className={"linkDiv"}></div>
          )}
        </Col>
        <Col style={{ justifyContent: "bottom" }}>
          <RiskInformationFilters
            gridApi={gridApi}
            loading={loading}
            rowData={riskInformationList}
            detailFilters={detailFilters}
            setDetailFilters={(newActive: any) => setDetailFilters(newActive)}
          />
        </Col>
      </Row>
      <Row className={"TableContainer"}>
        <Col style={{ display: "flex", flexDirection: "column" }}>
          <RiskInformationTable
            riskInformationList={riskInformationList}
            frcList={frcList}
            userEmailValidated={userEmailValidated}
            feedbackModified={riskRecordsModified}
            setGridApi={setGridApi}
            detailFilters={detailFilters}
            loading={loading}
          />
        </Col>
      </Row>
      <Modal
        isOpen={displayExportModal}
        className="modal-dialog"
        modalClassName="add-bu-modal"
      >
        <RiskInformationExportModal
          close={closeExportModal}
          loading={loading}
          gridApi={gridApi}
        />
      </Modal>

      <Modal
        isOpen={displaySaveModal}
        className="modal-dialog"
        modalClassName="add-bu-modal"
      >
        <RiskInformationSaveModal
          close={closeSaveModal}
          loading={saving}
          riskRecordsModified={riskRecordsModified}
          unmountOnClose={true}
          userEmailValidated={userEmailValidated}
        />
      </Modal>

      <Modal
        isOpen={displayResetModal}
        className="modal-dialog"
        modalClassName="add-bu-modal"
      >
        <RiskInformationResetModal
          close={closeResetModal}
          riskRecordsModified={riskRecordsModified}
        />
      </Modal>
    </Col>
  );
}

export default Sherlock;
